import { render, staticRenderFns } from "./ikhtisar-table.vue?vue&type=template&id=79c4f43c&scoped=true&"
import script from "./ikhtisar-table.vue?vue&type=script&lang=js&"
export * from "./ikhtisar-table.vue?vue&type=script&lang=js&"
import style0 from "./ikhtisar-table.vue?vue&type=style&index=0&id=79c4f43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4f43c",
  null
  
)

export default component.exports